import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './IssueRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.issue
    ? _c(
        "div",
        {
          staticClass: "issue",
          attrs: { resolved: _vm.isResolved, appearance: _vm.appearance }
        },
        [
          _vm.issueType
            ? _c("IssueTypeRenderer", {
                staticClass: "issue-type",
                attrs: { value: _vm.issueType }
              })
            : _c(
                "div",
                { staticClass: "issue-type unknown-type" },
                [_c("QuestionIcon", { attrs: { size: "xsmall" } })],
                1
              ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "issue-key",
              attrs: { href: _vm.href, target: "_blank" }
            },
            [_vm._v(_vm._s(_vm.issue.key))]
          ),
          _vm._v(" "),
          _vm.appearance !== "micro"
            ? _c(
                "div",
                {
                  staticClass: "issue-summary",
                  attrs: { title: _vm.fields.summary }
                },
                [_vm._v("\n        " + _vm._s(_vm.fields.summary) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appearance === "normal"
            ? [
                _vm.priority
                  ? _c("IssuePriorityRenderer", {
                      attrs: { value: _vm.priority }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.assignee
                  ? _c("User", {
                      staticClass: "issue-assignee",
                      attrs: { user: _vm.assignee, "avatar-only": true }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.status
                  ? _c("IssueStatusRenderer", {
                      staticClass: "issue-status",
                      attrs: { value: _vm.status }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-69648826";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/IssueRenderer.vue.js